import React from "react";
import { Link } from "react-router-dom";
import "./HHero.scss";
import PropTypes from "prop-types";

export const HHero = ({
  callToAction,
  height = "calc(max(73vh, 500px))",
  background,
  logos,
  displayStyle = "default",
  style = {},
  subtitle,
  supertitle,
  title,
  className = "",
  ...props
}) => {
  return (
    <section
      className={`hireart-ds-hero hireart-ds-hero-${displayStyle} ${className}`}
      style={{
        ...style,
        height: height,
        background: background
          ? `linear-gradient(0deg, rgba(255, 255, 255, 0.34), rgba(255, 255, 255, 0.34)), linear-gradient(9.74deg, ${background[0]} 3.5%, ${background[1]} 98.33%)`
          : "transparent",
      }}
    >
      <section className="hireart-ds-hero-content">
        {supertitle && (
          <div className="hireart-ds-hero-supertitle">{supertitle}</div>
        )}
        <h1>{title}</h1>
        {subtitle && <p className="hireart-ds-hero-subtitle">{subtitle}</p>}
        {callToAction && (
          <div className="hireart-ds-hero-cta">{callToAction}</div>
        )}
        {Boolean(logos && logos.length) && (
          <p className="hireart-ds-hero-logos">
            {logos.map((logo) => (
              <img src={logo} key={logo} />
            ))}
          </p>
        )}
        {props.children}
      </section>
    </section>
  );
};

HHero.propTypes = {
  backgroundImage: PropTypes.string,
  callToAction: PropTypes.element,
  height: PropTypes.string,
  logos: PropTypes.arrayOf(PropTypes.string),
  subtitle: PropTypes.string,
  supertitle: PropTypes.string,
  style: PropTypes.any,
  displayStyle: PropTypes.string,
  title: PropTypes.string,
};

